enum ActionType {
    REQUEST_LOCATIONS = '[CORE/LOCATIONS] GET LOCATIONS',
    SET_LOCATIONS = '[CORE/LOCATIONS] SET LOCATIONS',
}

export default ActionType
